
import { ControlFacet } from '../models/controls/ControlFacet';
import { openItem } from '../operations/openItem';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';

/**
 * @public
 */
export interface IOpenActionControlProps {
  /**
   * The item key for the current ItemsScope performing the 'open'.
   */
  itemsScopeItemKey: string;
}

/**
 * @public
 */
export interface IOpenActionControlOverrides {
  /**
   * Override for the item key which is to be opened.
   */
  itemKey: string;
  /**
   * Hook to 'stage' any relevant data for the item which is to be opened.
   * In general, any override should invoke the original provided to the handler.
   */
  stageItem: (payload: typeof openItem.payloadType) => IItemCacheThunkAction<Promise<void>>;
  /**
   * Hook to override the manner in which the item is opened.
   * In general, any override should invoke the original provided to the handler.
   */
  openItem: (payload: typeof openItem.payloadType) => IItemCacheThunkAction<void>;
}

/**
 * Control hook for overriding how ItemsScope 'opens' items, setting the current item to a target.
 */
export const openActionControl: ControlFacet<IOpenActionControlProps, IOpenActionControlOverrides> = new ControlFacet('openActionControl');
